// extracted by mini-css-extract-plugin
export default {"row":"SubscriptionTable_row__nQZGo","list":"SubscriptionTable_list__zRgkp"};